/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ScholarshiptypeId202,
  DeleteApiV1ScholarshiptypeId401,
  DeleteApiV1ScholarshiptypeId404,
  DeleteApiV1ScholarshiptypeId500,
  DeleteApiV1ScholarshiptypeIdMutationResponse,
  DeleteApiV1ScholarshiptypeIdPathParams,
} from "../../types/scholarshipTypeRegistroController/DeleteApiV1ScholarshiptypeId.ts";

export const deleteApiV1ScholarshiptypeIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ScholarshiptypeIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1ScholarshiptypeId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ScholarshiptypeId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ScholarshiptypeId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ScholarshiptypeId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ScholarshiptypeId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ScholarshiptypeId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ScholarshiptypeId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ScholarshiptypeId500>;

export const deleteApiV1ScholarshiptypeIdMutationResponseSchema = z.lazy(
  () => deleteApiV1ScholarshiptypeId202Schema,
) as unknown as ToZod<DeleteApiV1ScholarshiptypeIdMutationResponse>;
